import angular from 'angular';

/**
 * Controla el diálogo de duplicar incidencia.
 */
IncidenciaDuplicadaCtrl.$inject = ['$log', '$scope', '$http', 'dialogService'];
export default function IncidenciaDuplicadaCtrl($log, $scope, $http, dialogService) {
    var DIALOG_RELACIONAR_TEMPLATE = require('./relacionar/relacionarIncidenciaDialog.html');
    var DIALOG_RELACIONAR_ID = 'dialog_relacionarIncidencia';

    $scope.sePuedeRelacionar = Sigo.user.esAdmin && $scope.model.sePuedeRelacionar;
    $scope.hayPadreDuplicada = $scope.model.hayPadreDuplicada;

    $scope.relacionarIncidencia = function () {
        var titulo = ucfirst(Lang.choice('nombres.relacionar', 1)) + ' ' + Lang.choice('nombres.incidencia', 1);

        var extraOptions = {
            botonOk: ucfirst(Lang.choice('nombres.aceptar', 1)),
            botonCancel: ucfirst(Lang.get('nombres.cancelar')),
            validate: function (model) {
                if (!(issetAndNotEmpty(model) && angular.isDefined(model.tarea) && angular.isObject(model.tarea))) {
                    Sigo.UI.Messages.open([Lang.get('mensajes.no_selec_inci')], false);
                    return false;
                }
                return true;
            }
        };

        var options = {
            title: titulo
        };

        dialogService.open(DIALOG_RELACIONAR_ID, DIALOG_RELACIONAR_TEMPLATE, {id: $scope.model.id}, options, extraOptions)
            .then(function (model) {
                $http.post(Sigo.var.path + '/incidencias/relacionar-incidencia/' + model.id + '/' + model.tarea.originalObject.codigo,
                    {tipo: model.motivo, descripcion: model.descripcion})
                    .success(function (data) {
                        Sigo.UI.Messages.open(data.messages, 0);
                        actualizaFilaVIncidencia(data.vIncidencia);
                        $scope.sePuedeRelacionar = false;
                        $scope.hayPadreDuplicada = true;
                    })
                    .error(function (data) {
                        Sigo.UI.Messages.open([data.error.message], 0);
                    });
            });
    };
}